module.exports = __webpack_public_path__ + "img/banner.b35c63dc.png";